<template>
  <div class="edit-detailed-list">
    <contact-top
      :contactid="contactid"
      :contact-name="name"
      @setContactName="setContactName"
    />
    <!-- table -->
    <contact-table
      :contactid="contactid"
      :get-contact-name="getContactName"
    />
  </div>
</template>

<script>
import ContactTop from './Top'
import ContactTable from './Table'

export default {
  name: 'EditContactList',
  components: {
    ContactTop,
    ContactTable
  },

  props: {
    contactid: {
      type: [String, Number],
      default: ''
    }
  },

  data () {
    return {
      name: ''
    }
  },

  computed: {
    /* detailedid () {
      return this.$route.params.detailedid
    } */
  },

  methods: {
    getContactName (name) {
      this.name = name
    },
    setContactName (name) {
      this.name = name
    }
  }
}
</script>

<style scoped lang="scss">
.back-top {
  margin-bottom: 24px;
  color: #B3B3B3;
  i {
    margin: 0 6px;
  }
}
.detailed-name {
  .name {
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    font-weight: bold;
  }
  .iconfont {
    height: 32px;
    line-height: 32px;
    margin-right: 16px;
    color: #ccc;
  }
  .ant-form {
    margin-right: 16px;
  }
}
</style>
